module.exports = __webpack_public_path__ + "img/9-10.50268a94.png";